import { Link } from "react-router-dom";
import { FadeIn } from "./Reveal";
import { aud } from "@/lib/api";
import { IMAGES } from "@/data/site";

const ToolkitCard = ({ product, onDetails, onAdd, added, index = 0 }) => (
  <FadeIn delay={(index % 3) * 0.08} className="h-full">
    <article
      className="group h-full flex flex-col bg-white border border-cloud hover:border-teal transition-all duration-300 hover:-translate-y-1 hover:shadow-lg overflow-hidden"
      data-testid={`toolkit-card-${product.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-sand-light">
        <img
          src={IMAGES[product.image]}
          alt={product.title}
          loading="lazy"
          className={`w-full h-full transition-transform duration-700 group-hover:scale-105 ${
            product.image.endsWith("_cover") ? "object-contain" : "object-cover"
          }`}
        />
        <span className="absolute top-3 left-3 bg-ivory/95 text-teal text-[11px] font-mono uppercase tracking-[0.16em] px-3 py-1.5">
          {product.tag}
        </span>
        <span
          className={`absolute bottom-3 right-3 text-[11px] font-mono uppercase tracking-[0.16em] px-3 py-1.5 ${
            product.available ? "bg-teal text-ivory" : "bg-ivory/95 text-charcoal/60"
          }`}
          data-testid={`toolkit-status-${product.id}`}
        >
          {product.available ? "Instant PDF" : "Coming soon"}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h3 className="font-serif text-xl text-teal tracking-tight leading-snug">
          <Link
            to={`/toolkits/${product.id}`}
            data-testid={`toolkit-title-link-${product.id}`}
            className="hover:underline underline-offset-4 decoration-sand"
          >
            {product.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-charcoal/70 leading-relaxed line-clamp-3">
          {product.description}
        </p>
        <div className="mt-auto pt-5 flex items-center justify-between gap-3">
          <span className="font-serif text-2xl text-teal">{aud(product.price)}</span>
          <div className="flex gap-2">
            <button
              onClick={() => onDetails(product)}
              data-testid={`toolkit-details-button-${product.id}`}
              className="text-xs font-mono uppercase tracking-[0.14em] text-teal border border-cloud px-3 py-2 hover:border-teal transition-colors"
            >
              Preview
            </button>
            <button
              onClick={() => product.available && onAdd(product)}
              disabled={!product.available}
              data-testid={`toolkit-buy-button-${product.id}`}
              className={`text-xs font-mono uppercase tracking-[0.14em] px-3 py-2 transition-colors ${
                !product.available
                  ? "bg-sand-light text-charcoal/45 cursor-not-allowed"
                  : added
                  ? "bg-seaglass-light text-teal border border-seaglass"
                  : "bg-teal text-ivory hover:bg-teal-dark"
              }`}
            >
              {!product.available ? "Soon" : added ? "Added" : "Add"}
            </button>
          </div>
        </div>
      </div>
    </article>
  </FadeIn>
);

export default ToolkitCard;
